// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // Correct import for React 18
import { Provider } from 'react-redux';
import App from './App';
import store from './store'; // Adjust the path to your store file if necessary

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  // Do not pass `container` here
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
